import * as React from "react";
import type { Theme } from "src/theme";

const flex = ({ gridUnit }: Theme) => ({
  justifyContent: "space-between",
  display: "flex",
  flexDirection: "column" as const,
  paddingTop: gridUnit * 2,
  marginBottom: gridUnit * 4
});
type Props = {
  children: React.ReactNode;
};
const RadioButtonGroup = (props: Props): React.ReactNode => {
  return <div css={flex}>{props.children}</div>;
};

export default RadioButtonGroup;
